// extracted by mini-css-extract-plugin
export var childrenContainer = "_c6-0";
export var virtualScrollArea = "_c6-1";